export const SET_SEARCH_TERM_DATA = 'SET_SEARCH_TERM_DATA';
